import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import DoorMainTab from './DoorMainTab';
import Door from './Door';

const TabContent = ({
  activeTabIndex,
}) => {
  const { currentSystem } = useSelector(({ systems }) => systems);

  const getTabContent = () => {
    if (activeTabIndex === 0 || currentSystem === 'frame-facades') {
      return (<DoorMainTab />);
    }

    return (
      <Door doorNumber={activeTabIndex} />
    );
  };

  return (
    <div className="">
      {getTabContent()}
    </div>
  );
};

TabContent.defaultProps = {
  activeTabIndex: 0,
};

TabContent.propTypes = {
  activeTabIndex: PropTypes.number,
};

export default TabContent;
